import { useState } from "react";
import { MemberLayout } from "../../components/Layouts";
import { api, readUser, errMsg } from "../../lib/api";

export default function Security() {
  const user = readUser();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [notice, setNotice] = useState({ ok: false, msg: "" });
  async function save(e) {
    e.preventDefault();
    setNotice({ ok: false, msg: "" });
    if (form.new_password !== form.confirm) { setNotice({ ok: false, msg: "New passwords do not match." }); return; }
    try {
      await api.put("/profile/password", { current_password: form.current_password, new_password: form.new_password });
      setNotice({ ok: true, msg: "Password updated." });
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (e) { setNotice({ ok: false, msg: errMsg(e) }); }
  }
  return (
    <MemberLayout user={user} active="Security">
      <div className="deposit-grid">
        <div className="panel">
          <div className="panel-heading"><div><span className="eyebrow">CHANGE PASSWORD</span><h3>Keep access protected</h3></div></div>
          <form onSubmit={save} className="deposit-form">
            <label>Current password<input data-testid="sec-current-password" type="password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} required /></label>
            <label>New password<input data-testid="sec-new-password" type="password" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} required /></label>
            <label>Confirm new password<input data-testid="sec-confirm-password" type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} required /></label>
            {notice.msg && <div className={notice.ok ? "success" : "error"} data-testid="sec-notice">{notice.msg}</div>}
            <button className="btn btn-accent full" data-testid="sec-save">Update password</button>
          </form>
        </div>
        <div className="panel activity">
          <div className="panel-heading"><div><span className="eyebrow">PROTECTIONS</span><h3>What we do for you</h3></div></div>
          <ul className="lifecycle">
            <li>Passwords are stored with bcrypt (never in clear text)</li>
            <li>Sessions use httpOnly, secure cookies</li>
            <li>Role-based access control for admin actions</li>
            <li>Wallet changes require password confirmation</li>
            <li>Transaction ledger with before/after balances for every change</li>
            <li>Protected requests require an authenticated member session</li>
          </ul>
        </div>
      </div>
    </MemberLayout>
  );
}
